export default "__VITE_ASSET__DxUaIqpN__"